export const deleteSearchParams = (params: URLSearchParams, keys: string[]) => {
  keys.forEach((key) => {
    if (params.has(key)) {
      params.delete(key);
    }
  });

  return params;
};

export const addSearchParams = (
  params: URLSearchParams,
  keys: { name: string; value: string }[],
) => {
  keys.forEach((key) => {
    params.set(key.name, key.value);
  });

  return params;
};
